import { IntroWidget } from "common/IntroWidget";
import { SegmentMatchListItem } from "common/ListItems";
import { SearchableCard } from "common/SearchableCard";
import styles from "common/SearchableCard/SearchableCard.scss";
import { CTA } from "common/styleguide/CTA";
import { troutesMessages } from "features/homepage/shared/intlMessages";
import { DEFAULT_PER_PAGE } from "lib/loadAllPages";
import { commonCTAs, commonMessages, Msg } from "lib/localization";
import React from "react";
import { FormattedMessage as T } from "react-intl";

export class MatchedSegments extends React.PureComponent {
  state = {
    keywords: "",
    limit: DEFAULT_PER_PAGE,
  };

  loadMore = () => {
    this.setState((state) => ({ limit: state.limit + DEFAULT_PER_PAGE }));
  };

  render() {
    const { keywords, limit } = this.state;
    const { segmentMatches } = this.props;

    const matches = keywords
      ? segmentMatches.filter(({ name }) => name.toLowerCase().includes(keywords.toLowerCase()))
      : segmentMatches;
    const toShow = matches.slice(0, limit);
    return (
      <SearchableCard
        keywords={keywords}
        onChange={(e) => this.setState({ keywords: e.target.value, limit: DEFAULT_PER_PAGE })}
        resultsCount={matches.length}
        resultsLength={toShow.length}
      >
        {toShow.map((match) => (
          <SegmentMatchListItem key={match.slug} match={match} />
        ))}
        {segmentMatches.length === 0 && !keywords && (
          <IntroWidget
            large
            i="md-podium"
            link={
              <a href="https://ridewithgps.com/help/segments" target="_blank">
                <T id="MatchedSegments.learn" defaultMessage="Learn About Segments" />
              </a>
            }
          >
            <T id="MatchedSegments.noMatches" defaultMessage="You have no matched segments" />
          </IntroWidget>
        )}
        {toShow.length === 0 && keywords.length > 0 && (
          <IntroWidget large i="md-podium">
            <Msg m={troutesMessages.noneMatched} />
          </IntroWidget>
        )}
        {matches.length > toShow.length && (
          <div className={styles.resultsFooter}>
            <CTA inline secondary margins={false} onClick={() => this.loadMore()}>
              <Msg m={commonCTAs.loadMore} />
            </CTA>
            <div style={{ paddingTop: "20px" }}>
              <span className={styles.footerText}>
                <Msg m={commonMessages.showingResults} values={{ length: toShow.length, totalCount: matches.length }} />
              </span>
            </div>
          </div>
        )}
        {matches.length === toShow.length && toShow.length > DEFAULT_PER_PAGE && (
          <div className={styles.resultsFooter}>
            <span className={styles.footerText}>
              <Msg m={commonMessages.noMoreItems} />
            </span>
          </div>
        )}
      </SearchableCard>
    );
  }
}
